package com.essntl.features.client.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.focusProperties
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.uikit.components.button.custom.EsListDialogButton
import com.essntl.uikit.components.tooltip.EsTooltip

@Composable
fun ClientDialogButton(
    client: ClientModel?,
    onClick: (ClientModel) -> Unit,
    modifier: Modifier = Modifier,
) {
    val clientDisplayName =
        remember(client?.firstName, client?.lastName) {
            client?.prettyName ?: "-"
        }

    EsTooltip(
        text = if (client == null) "No client" else
            clientDisplayName,
    ) {
        EsListDialogButton(
            onClick = {
                if (client != null)
                    onClick(client)
            },
            text = clientDisplayName,
            modifier = modifier.focusProperties { canFocus = false },
        )
    }
}
